/**
 * 通知ヘルパー関数
 *
 * Mantine notifications の共通ラッパーを提供します。
 * 一貫したスタイルと簡潔な呼び出しを実現します。
 */

import { notifications } from "@mantine/notifications";

/**
 * 成功通知を表示
 * @param message 通知メッセージ
 * @param title タイトル（デフォルト: "成功"）
 */
export function showSuccess(message: string, title = "成功") {
  notifications.show({
    title,
    message,
    color: "green",
  });
}

/**
 * エラー通知を表示
 * @param message 通知メッセージ
 * @param title タイトル（デフォルト: "エラー"）
 */
export function showError(message: string, title = "エラー") {
  notifications.show({
    title,
    message,
    color: "red",
  });
}

/**
 * 警告通知を表示
 * @param message 通知メッセージ
 * @param title タイトル（デフォルト: "注意"）
 */
export function showWarning(message: string, title = "注意") {
  notifications.show({
    title,
    message,
    color: "orange",
  });
}

/**
 * 情報通知を表示
 * @param message 通知メッセージ
 * @param title タイトル（デフォルト: "お知らせ"）
 */
export function showInfo(message: string, title = "お知らせ") {
  notifications.show({
    title,
    message,
    color: "blue",
  });
}
